(() => {
  window.pyEditorialMotion?.destroy();
  const aborter = new AbortController();
  const {signal} = aborter;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const active = new Map();
  const selector = '.py-homev2__manifest>div,.py-homev2__products header,.py-homev2__product,.py-homev2__craft-copy,.py-homev2__story-copy,.py-homev2__links>a,.py-homev2__closing .py-homev2__shell,.py-intro,.py-person__copy,.py-base__old,.py-base__next,.py-homehonors__head,.py-craftv2__intro,.py-craft__film header,.py-craft__stage,.py-ipdp__details,.py-editorial-card,.py-qcontact__intro';
  const heroSelector = '.py-homev2__hero-copy>p,.py-homev2__hero-copy>h1,.py-homev2__hero-copy>span,.py-homev2__hero-copy>div';
  function play(target, delay = 0) {
    if (reduced.matches || document.hidden || typeof target.animate !== 'function') return;
    active.get(target)?.cancel();
    const card = target.matches('.py-homev2__product,.py-editorial-card,.py-craft__stage,.py-homev2__links>a');
    // Keep product imagery visible; retain motion without a blank staggered reveal.
    const visibleMedia = target.matches('.py-homev2__product,.py-editorial-card');
    if (visibleMedia) delay = 0;
    const animation = target.animate([
      {opacity:visibleMedia?1:0,transform:`translate3d(0,${card?38:28}px,0) scale(${card ? .955 : .98})`,offset:0},
      {opacity:1,transform:`translate3d(0,${card?-4:-2}px,0) scale(1.006)`,offset:.76},
      {opacity:1,transform:'translate3d(0,0,0) scale(1)',offset:1}
    ],{duration:card?960:1050,delay,easing:'cubic-bezier(.2,.75,.25,1)',fill:'backwards'});
    active.set(target,animation);
    animation.finished.catch(()=>{}).finally(()=>{if(active.get(target)===animation)active.delete(target);});
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    let order=0;
    entries.filter(entry=>entry.isIntersecting).sort((a,b)=>a.boundingClientRect.top-b.boundingClientRect.top||a.boundingClientRect.left-b.boundingClientRect.left).forEach(({target})=>{
      observer.unobserve(target);
      play(target,Math.min(order++*85,340));
    });
  },{threshold:.06}) : null;
  function scan(root=document) {
    if(!observer)return;
    const candidates=[...root.querySelectorAll(selector)];
    if(root.matches?.(selector))candidates.unshift(root);
    candidates.forEach(el=>{
      if(seen.has(el))return;
      seen.add(el);
      observer.observe(el);
    });
  }
  function cancel(){active.forEach(animation=>animation.cancel());active.clear();}
  function destroy(){cancel();observer?.disconnect();aborter.abort();}
  reduced.addEventListener('change',()=>{if(reduced.matches)cancel();},{signal});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)cancel();},{signal});
  document.addEventListener('shopify:section:load',event=>scan(event.target),{signal});
  document.addEventListener('shopify:section:unload',event=>{
    event.target.querySelectorAll(selector+','+heroSelector).forEach(el=>{observer?.unobserve(el);active.get(el)?.cancel();});
  },{signal});
  function boot(){
    scan();
    [...document.querySelectorAll(heroSelector)].forEach((el,i)=>{if(el.getBoundingClientRect().bottom>0&&el.getBoundingClientRect().top<innerHeight)play(el,i*110);});
  }
  window.pyEditorialMotion={scan,destroy};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true,signal});else boot();
})();
